module.exports = __webpack_public_path__ + "static/media/214x152_6 copy.76eac9a8.png";